import type {
  TntDataSet,
  TntDataSetType,
  TntJob,
  TntSource,
  TntUsageType,
} from '../services/TimeInTransitService/types';

export const TNT_OVERRIDE_MESSAGE =
  'You have chosen to override your production time in transit settings with an uploaded file for this simulation.';

export interface TimeInTransitStateMap extends TntDataSetType {
  dataSets: TntDataSet[];
  tntSource: TntSource;
  tntJobs: TntJob[];
}

export type TimeInTransitState = Record<string, TimeInTransitStateMap>;

export interface TimeInTransitTableData {
  dataSetTypeId: string;
  dataSetId: string;
  tntSourceId: string;
  name: string;
  description: string;
  tntSource: string;
  createdBy: string;
  writeCompletedAt: string;
  expirationTimestamp: string;
  usage: TntUsageType;
  tntJobs: TntJob[];
}

export interface DataSetVersionsResponse {
  dataSetVersions: {
    id: string;
    dataSetId: string;
    name: string;
    versionNumber: number;
    metadata: any;
    writeCompletedAt: string;
    deletedAt: string;
    auditInfo: any;
  }[];
}

export interface PaginatedTntData {
  carrierScope: {
    id: string;
    type: string;
  };
  id: string;
  metadata: any;
  route: {
    originDestination: {
      destination: {
        countryCode: string;
        postalCode: string;
      };
      origin: {
        countryCode: string;
        postalCode: string;
      };
    };
  };
  tntDimensionsByTime: {
    [key: string]: {
      tntByDimension: {
        [key: string]: number;
      };
    };
  };
}

export interface PaginatedTntTableData {
  originCountry: string;
  originPostal: string;
  destinationCountry: string;
  destinationPostal: string;
  carrierServiceMethodId: string;
  tnt: number;
}

export interface TimeInTransitProductionTableData {
  dataSetTypeId: string;
  dataSets: TntDataSet[];
  id: string;
  dataSetName: string;
  description: string;
  deletedAt: string;
  writeCompletedAt: string;
  metadata?: any;
  tntJobs?: TntJob[];
  active: boolean;
}

export interface TimeInTransitProdTableData {
  dataSetTypeId: string;
  dataSets: TntDataSet[];
  name: string;
  description: string;
  tntSource: string;
  createdBy: string;
  writeCompletedAt: string;
  expirationTimestamp: string;
  usage: TntUsageType;
  tntJobs: TntJob[];
}
